import React, {useContext} from 'react'
import  Language  from '../../Context/Language'
import NextMatches from '../headtohead/NextMatches'
import TeamsInfo from '../headtohead/TeamsInfo'



export default function Fixture() {
  const data = useContext(Language)
  return (
    <div>
      <TeamsInfo/>
      <NextMatches/>
    </div>
   
  )
}
